import UserAvatar from '@/components/common/Images/Avatar';
import TextExpander from '@/components/common/TextExpander';
import { Disclosure, Tab } from '@headlessui/react';
import { CameraIcon, MapIcon, MinusIcon, PlusIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';

import { UidCodeButton } from '@/components/common/Buttons';
import BookLocationMap from '@/components/Pages/Bookle/BookLocationMap';
import Pill from '@/components/Pages/Bookle/Pill';

const POLISH_CITIES_GEOLOCATION = require('@/assets/files/cities-locations.json');

const details = [
  {
    name: 'Nagrania',
    items: ['Na tym egzemplarzu znajdują się nagrania. Znajdź go aby posłuchać.'],
  },
  // Add this sections if there is more than one location
  // {
  //   name: 'Poprzedni Właściciele',
  //   items: ['Username'],
  // },
];

export default function BookCopyPage({ bookcopy, bookisbn, nearbyCity }) {
  let [isMapSelected, setIsMapSelected] = useState(true);

  return (
    <div className="bg-white">
      <main className="mx-auto max-w-7xl sm:px-6 sm:pt-16 lg:px-8">
        <div className="mx-auto max-w-2xl lg:max-w-none">
          {/* Product */}
          <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
            {/* Image gallery */}
            <Tab.Group as="div" className="flex flex-col-reverse">
              {/* Image selector */}
              {/* <div className="mx-auto mt-6 hidden w-full max-w-2xl sm:block lg:max-w-none">
                <Tab.List className="grid grid-cols-4 gap-6">
                  {product.images.map((image) => (
                    <Tab
                      key={image.id}
                      className="relative flex h-24 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium uppercase text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-offset-4"
                    >
                      {({ selected }) => (
                        <>
                          <span className="sr-only">{image.name}</span>
                          <span className="absolute inset-0 overflow-hidden rounded-md">
                            <img
                              src={image.src}
                              alt=""
                              className="h-full w-full object-cover object-center"
                            />
                          </span>
                          <span
                            className={clsx(
                              selected ? 'ring-teal-500' : 'ring-transparent',
                              'pointer-events-none absolute inset-0 rounded-md ring-2 ring-offset-2'
                            )}
                            aria-hidden="true"
                          />
                        </>
                      )}
                    </Tab>
                  ))}
                </Tab.List>
              </div> */}

              <Tab.Panels className="aspect-h-1 aspect-w-1 w-full">
                {!isMapSelected ? (
                  <BookLocationMap marker={bookcopy.coordinates} />
                ) : (
                  <Tab.Panel key={bookcopy.id}>
                    <Image
                      src={
                        bookcopy.thumbnailBig
                          ? bookcopy.thumbnailBig
                          : bookisbn.thumbnailBig
                          ? bookisbn.thumbnailBig
                          : require('@/assets/images/book_cover_unavailable.png')
                      }
                      alt={bookcopy.title}
                      className="h-full w-full object-cover object-center sm:rounded-lg"
                      fill
                    />
                  </Tab.Panel>
                )}
              </Tab.Panels>
            </Tab.Group>

            {/* Product info */}
            <div className="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
              <p className="text-xl tracking-tight text-yellow-700">
                Strona internetowa egzemplarza książki pt.:
              </p>
              <h1 className="text-4xl font-semibold tracking-tight text-gray-900">
                {bookisbn.title}
              </h1>
              <p className="text-xl  tracking-tight text-gray-700">{bookisbn.author}</p>
              <div className="mt-6">
                <h3 className="sr-only">Opis</h3>

                {bookisbn.description && (
                  <div className="space-y-6 text-base text-gray-700">
                    <TextExpander text={bookisbn.description} />
                  </div>
                )}
              </div>

              <h2 className="mt-5 text-2xl font-semibold tracking-tight text-gray-600">
                Informacje o egzemplarzu:
              </h2>
              <div className="mt-3">
                <span className="sr-only">Informacje o egzemplarzu książki</span>
                <UidCodeButton uid={bookcopy.uid} size="xl" disable></UidCodeButton>
              </div>
              <div className="mt-1">
                <Pill>
                  <MapIcon
                    className={clsx('h-7 w-7', 'my-auto ml-1.5 flex-shrink-0 text-blue-400')}
                    aria-hidden="true"
                  />
                  {`Ostatnio widziana w okolicach ${
                    nearbyCity ? nearbyCity : 'jeszcze nieznanych.'
                  }`}
                </Pill>
              </div>

              <div className="mt-1 flex">
                <Pill>Ostatni właściciel:</Pill>
                <UserAvatar user={bookcopy.user} showName></UserAvatar>
              </div>

              <form className="mt-6">
                <div className="mt-10 flex">
                  {/* <button
                    type="submit"
                    className="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-teal-600 px-8 py-3 text-base font-medium text-white hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
                  >
                    Napisz do Właściciela
                  </button> */}

                  {/* <button
                    type="submit"
                    className="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-teal-600 px-8 py-3 text-base font-medium text-white hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
                  >
                    Kup
                  </button> */}

                  <button
                    onClick={() => setIsMapSelected(true)}
                    type="button"
                    className="ml-4 flex items-center justify-center rounded-md px-3 py-3 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
                  >
                    <MapIcon className="h-6 w-6 flex-shrink-0" aria-hidden="true" />
                    <span className="sr-only">Pokaż ostatniego właściciela</span>
                  </button>
                  {/* TODO: Dodać możliwość podglądu trasy książki w przypadku większej ilości lokacji */}
                  {/* <button
                    type="button"
                    className="ml-4 flex items-center justify-center rounded-md px-3 py-3 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
                  >
                    <MapIcon className="h-6 w-6 flex-shrink-0" aria-hidden="true" />
                    <span className="sr-only">Pokaż trasę egzemplarza</span>
                  </button> */}
                  <button
                    onClick={() => setIsMapSelected(false)}
                    type="button"
                    className="ml-4 flex items-center justify-center rounded-md px-3 py-3 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
                  >
                    <CameraIcon className="h-6 w-6 flex-shrink-0" aria-hidden="true" />
                    <span className="sr-only">Pokaż Zdjęcie</span>
                  </button>
                </div>
              </form>

              <section aria-labelledby="details-heading" className="mt-12">
                <h2 id="details-heading" className="sr-only">
                  Additional details
                </h2>

                <div className="divide-y divide-gray-200 border-t">
                  {details.map((detail) => (
                    <Disclosure as="div" key={detail.name}>
                      {({ open }) => (
                        <>
                          <h3>
                            <Disclosure.Button className="group relative flex w-full items-center justify-between py-6 text-left">
                              <span
                                className={clsx(
                                  open ? 'text-teal-600' : 'text-gray-900',
                                  'text-sm font-medium'
                                )}
                              >
                                {detail.name}
                              </span>
                              <span className="ml-6 flex items-center">
                                {open ? (
                                  <MinusIcon
                                    className="block h-6 w-6 text-teal-400 group-hover:text-teal-500"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <PlusIcon
                                    className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                    aria-hidden="true"
                                  />
                                )}
                              </span>
                            </Disclosure.Button>
                          </h3>
                          <Disclosure.Panel as="div" className="prose prose-sm pb-6">
                            <ul role="list">
                              {detail.items.map((item) => (
                                <li key={item}>{item}</li>
                              ))}
                            </ul>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  ))}
                </div>
              </section>
            </div>
          </div>
          <div className="py-10">{'  '}</div>
          {/* <SectionAlsoSearchedFor></SectionAlsoSearchedFor> */}
        </div>
      </main>
    </div>
  );
}

BookCopyPage.layout = 'Main';

export async function getServerSideProps({ query }) {
  let uri = `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/bookle/bookcopies?uid=${query.bookcopy}`;

  let bookcopy = await fetch(uri);
  bookcopy = await bookcopy.json();
  bookcopy = bookcopy.results[0];

  let bookisbn = bookcopy.isbn;

  // https://www.npmjs.com/package/geo-nearby
  const Geo = require('geo-nearby');

  const dataSet = Geo.createCompactSet(POLISH_CITIES_GEOLOCATION);
  const geo = new Geo(dataSet, { sorted: true });

  let latLng = bookcopy.coordinates;

  let nearbyCity = '';

  let res = geo.limit(1).nearBy(latLng[0], latLng[1], [5000, 500000]); // meters
  if (res && res.length > 0 && res[0].i) {
    nearbyCity = res[0].i;
  }

  return {
    props: { bookcopy, bookisbn, nearbyCity },
  };
}
